import { Link } from "react-router-dom";
import "./index.css";
import TextTag from "../Tag";
import HeroVideo from "./HeroVideo";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__left">
        <TextTag text="Your daily time tracker" />
        <h1 className="hero__title">
          Track & <span> Build</span> <br />
          Habits
        </h1>
        <p className="hero__sub">
          A simple companion to track your daily activities, uncover how your
          time is really spent, and watch how your habits unfold along the way.
        </p>
        <div className="hero__btns">
          <Link to="/download" className="hero__btn-primary">
            Download free
          </Link>
          <a href="/how-it-works" className="hero__btn-secondary">
            How it works
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>

      <HeroVideo />
    </section>
  );
};

export default Hero;
